<div class="waiting-room-container">
  @if(testResultsShownInDevelop){
    <!-- CONTENIDO PROVISIONAL -->
    <div>
      <div>
        bitrate (bps):
        {{ testResultsShownInDevelop?.video?.bitrate }}
      </div>
      <div>
        mos:
        {{ testResultsShownInDevelop?.video?.mos }}
      </div>
      <div>
        supported by Opentok:
        {{ testResultsShownInDevelop?.video?.supportedByOpentok }}
      </div>
      <div>
        supported by Mos:
        {{ testResultsShownInDevelop?.video?.supported }}
      </div>
    </div>
  }
  <div class="overlay-background" #scrollPage [scrollTop]="(isMobile$ | async) ? scrollPage.scrollHeight : ''">
    <div class="waiting-room-header">
      <div class="waiting-room-logo">
        <img src="assets/img/diseno/logo.png" />
      </div>
      <!-- SUPPORT PHONE -->
      <div class="waiting-room-support">
        <!-- SUPPORT DESKTOP -->
        <div class="content">
          <p class="text" [translate]="'HEADER.TECHNICAL_SUPPORT'"></p>
          <p class="number">{{ supportPhone }}</p>
        </div>
        <div class="icon-desktop">
          <i class="icon-call_blue"></i>
        </div>
        <!-- BOTTON MOBILE SUPPORT MOBILE -->
        <div class="support-mobile-btn more-btn">
          <div class="suppor-icon" (click)="showSupportNumber()">
            <i class="icon-call_blue"></i>
            <p class="text" [translate]="'HEADER.TECHNICAL_SUPPORT'"></p>
          </div>
          <!-- CONTAINER TELÉFONO SOPORTE TOOLTIP -->
          <div class="support-number-container box-content">
            <sas-support-tooltip></sas-support-tooltip>
          </div>
          <!-- @if(!hide){
            <div class="box-content">
              <p class="text" [translate]="'HEADER.TECHNICAL_SUPPORT'"></p>
              <a href="tel:+{{ supportPhone }}" class="number">{{ supportPhone }}</a>
            </div>
          } -->
        </div>
      </div>
    </div>

    <div class="overlay-container">
      <div class="overlay-container-left">
        <div>
          <h1>
            <span>{{ 'DISCONNECTED.GREETING' | translate }} {{ mySelf }}</span>
          </h1>
          <h1>
            <span class="fw-normal" [translate]="'DISCONNECTED.NOT_FOUND.TITLE'"></span>
          </h1>
        </div>
      </div>
      <!-- OVERLEY CONTAINER NORMAL -->
      <div class="overlay-container-right">
        <!-- CONFIGURACIÓN GENERAL -->
        <div class="overlay-info-container">
          <!-- NUEVO TEST DE CONECTIVIDAD - 4 PASOS (CONEXIÓN, ALTAVOZ, MICRÓFONO Y CÁMARA)
                    para las barras de progreso utilizamos el mismo componente que tenemos para "meter-container wifi-test"  -->

          <!-- TEST DE CONEXIÓN -->
          @if(welcomeMessage && !dualCam){
            <!-- UNICO ESCENARIO 1: TEXTO + BARRA PROGRESO (si está todo ok pasamos a Test de altavoz) -->
            <div class="connection-settings">
              <i class="icon-wifi"></i>
              <div class="u-divider-bottom-xl u-divider-top-xl" [translate]="'MUTUA_NETWORK_TEST.CHECK_CONNECTION_INFO'">
              </div>
              <div class="overlay-setting-txt u-flex u-flex-column">
                <div class="meter-container wifi-test">
                  <div class="meter-level" [ngStyle]="{ 'width.%': levelWidth }"></div>
                </div>
              </div>
            </div>
          }
          @if(dualCam){
            <!-- ERROR POR INTENTAR USAR LA CAMARA EN DOS SITIOS  -->
            <div class="connection-settings">
              <i class="icon-wifi"></i>
              <div class="u-divider-bottom-xl" [innerHTML]="'MUTUA_NETWORK_TEST.DUAL_CAM_ERROR' | translate"></div>
            </div>
          }

          <!-- TEST DE ALTAVOZ -->
          @if(audioManualTestEnabled){
            <!-- ESCENARIO 1: TEXTO 1 + BOTÓN DE COMENZAR (al pulsar comenzar pasamos a escenario 2)
                ESCENARIO 2: TEXTO 2 + 2 BOTÓNES (NO / SI)  (si está todo ok pasamos a Test de micrófono) -->
            <div class="audio-settings">
              <i class="icon-display-audio"></i>
              @if(audioManualTestInfo){
                <div class="u-divider-bottom-xl u-divider-top-xl"
                  [translate]="'MUTUA_NETWORK_TEST.SPEAKER_TEST_INFO'"></div>
              }
              @if(audioManualTest && !audioStartTest){
                <div class="confirm-text"
                  [translate]="'MUTUA_NETWORK_TEST.SPEAKER_TEST_CONFIRM'"></div>
              }
              @if(!audioStartTest &&
                  enviroment.data.features.mediaDevices.speaker &&
                  audioOutputDevices &&
                  audioOutputDevices.length > 1){
                    <div class="select-container" [ngClass]="{ open: isOpen }">

                      <select (click)="isOpen = !isOpen" (blur)="isOpen = false" class="form-control col-12 desplegable"
                        (change)="onSeleccionarAudio($event.target)">
                        @for(audioOutputDevice of audioOutputDevices; track $index){
                          <!-- <option class="opciones"
                            [title]="audioOutputDevice.label" [value]="audioOutputDevice.deviceId">
                            {{ audioOutputDevice.truncatedLabel }}
                          </option> -->

                         <option
                            [selected]="audioOutputDevice.deviceId === defaultAudioOutputDeviceId"
                            class="opciones"
                            [title]="
                              audioOutputDevice.deviceId === defaultAudioOutputDeviceId
                                ? audioOutputDevice.label +
                                  ' (' +
                                  ('MUTUA_NETWORK_TEST.DEFAULT_DEVICE' | translate) +
                                  ')'
                                : audioOutputDevice.label
                            "
                            [value]="audioOutputDevice.deviceId"
                          >
                            {{ audioOutputDevice.truncatedLabel }}
                        </option>


                        }
                      </select>
                      <span class="arrow" [ngClass]="{ up: isOpen }">&#9660;</span>
                    </div>
              }
              @if(audioManualTest){
                <div [ngClass]="!audioStartTest ? 'u-flex u-flex-justify-content-between' : ''"
                  class="button-container u-divider-bottom-sm">
                  @if(audioStartTest){
                    <button class="btn btn-primary btn-lg u-divider-top-xxl" type="submit"
                      (click)="playAudio(); audioManualTestInfo = false">
                      {{ 'DISCONNECTED.AUDIO.START' | translate }}
                    </button>
                  }
                  @if(!audioStartTest){
                    <button class="btn btn-primary outline btn-lg u-divider-top-xxl" type="submit"
                      (click)="audioTestKo()">
                      {{ 'DISCONNECTED.AUDIO.NO' | translate }}
                    </button>
                    <button class="btn btn-primary btn-lg u-divider-top-xxl" type="submit"
                      (click)="audioTestOk()">
                      {{ 'DISCONNECTED.AUDIO.YES' | translate }}
                    </button>
                  }
                </div>
              }
            </div>
          }

          <!-- TEST DE MICROFONO -->
          @if(micManualTestEnabled){
            <!-- ESCENARIO 1: TEXTO 1 + BOTÓN DE COMENZAR (al pulsar comenzar pasamos a escenario 2)
                ESCENARIO 2: TEXTO 2 + BARRA PROGRESO + 2 BOTÓNES (NO / SI)  -->
            <div class="microphone-settings">
              <i class="icon-mic"></i>
              @if(micManualTestInfo){
                <div class="u-divider-bottom-xl u-divider-top-xl"
                  [translate]="'MUTUA_NETWORK_TEST.MIC_TEST_INFO'"></div>
              }
              @if(micManualTest && !micStartTest){
                <div class="confirm-text"
                  [translate]="'MUTUA_NETWORK_TEST.MIC_TEST_CONFIRM'"></div>
              }
              <div class="overlay-setting-txt u-flex u-flex-column">
                <div>
                  <meter id="publisherMeter" min="0" max="1" value="0"></meter>
                </div>
              </div>
              @if(enviroment.data.features.mediaDevices.microphone &&
                  audioDevices &&
                  audioDevices.length > 1){
                    <div class="select-container" [ngClass]="{ open: isOpen }">
                      <select (click)="isOpen = !isOpen" (blur)="isOpen = false" class="form-control col-12 desplegable"
                        (change)="onSeleccionar($event.target)">
                        @for(audioDevice of audioDevices; track $index){
                          <option class="opciones" [title]="audioDevice.label"
                            [value]="audioDevice.deviceId">
                            {{ audioDevice.truncatedLabel }}
                          </option>
                        }
                      </select>
                      <span class="arrow" [ngClass]="{ up: isOpen }">&#9660;</span>
                    </div>
                  }
              @if(micManualTest){
                <div [ngClass]="!micStartTest ? 'u-flex u-flex-justify-content-between' : ''"
                  class="button-container u-divider-bottom-sm">
                  @if(micStartTest){
                    <button class="btn btn-primary btn-lg u-divider-top-xxl" type="submit"
                      (click)="playMic(); micManualTestInfo = false">
                      {{ 'DISCONNECTED.AUDIO.START' | translate }}
                    </button>
                  }
                  @if(!micStartTest){
                    <button class="btn btn-primary outline btn-lg u-divider-top-xxl" type="submit"
                      (click)="micTestKo()">
                      {{ 'DISCONNECTED.AUDIO.NO' | translate }}
                    </button>
                    <button class="btn btn-primary btn-lg u-divider-top-xxl" type="submit"
                      (click)="micTestOk()">
                      {{ 'DISCONNECTED.AUDIO.YES' | translate }}
                    </button>
                  }
                </div>
              }
            </div>
          }

          <!-- TEST DE CÁMARA -->
          <!-- ESCENARIO 1: TEXTO 1 + BOTÓN DE COMENZAR (al pulsar comenzar pasamos a escenario 2, desaparce icono y vemos imagen cámara)
              ESCENARIO 2: IMAGEN CÁMARA + TEXTO 2 + 2 BOTÓNES (NO / SI)  (si está todo ok pasamos a  CONFIGURACIÓN GENERAL  overlay-info-container) -->
          <div class="cam-settings" [ngStyle]="{
              display: camManualTestEnabled ? 'block' : 'none',
              height: camManualTestEnabled ? 'auto' : '0px'
            }">
            <i class="icon-camera"></i>
            <div class="overlay-info-container-video" style="background-color: black">
              <div class="publisher-container publishing" #publisherDiv></div>
            </div>
            @if(camManualTestInfo){
              <div class="u-divider-bottom-xl u-divider-top-xl"
                [translate]="'MUTUA_NETWORK_TEST.CAM_TEST_INFO'"></div>
            }
            @if(camManualTest && !camStartTest){
              <div class="confirm-text"
                [translate]="'MUTUA_NETWORK_TEST.CAM_TEST_CONFIRM'"></div>
            }
            @if(!(isMobile$ | async) &&
                !(isTablet$ | async) &&
                enviroment.data.features.mediaDevices.camera &&
                videoDevices?.length > 1){
                  <div class="select-container" [ngClass]="{ open: isOpen }">
                    <select (click)="isOpen = !isOpen" (blur)="isOpen = false" class="form-control col-12 desplegable"
                      (change)="onSeleccionarCam($event.target)">
                      @for(videoDevice of videoDevices; track $index){
                        <option [title]="videoDevice.label"
                          [selected]="videoDevice.deviceId === defaultVideoInputDeviceId"
                          [value]="videoDevice.deviceId">
                          {{ videoDevice.truncatedLabel }}
                        </option>
                      }
                    </select>
                    <span class="arrow" [ngClass]="{ up: isOpen }">&#9660;</span>
                  </div>
            }
            @if(camManualTest){
              <div [ngClass]="!camStartTest ? 'u-flex u-flex-justify-content-between' : ''"
                class="button-container u-divider-bottom-sm" id="buttonsCamTest">
                @if(camStartTest){
                  <button class="btn btn-primary btn-lg u-divider-top-xxl" type="submit"
                    (click)="playCam(); camManualTestInfo = false">
                    {{ 'DISCONNECTED.AUDIO.START' | translate }}
                  </button>
                }
                @if(!camStartTest){
                  <button class="btn btn-primary outline btn-lg u-divider-top-xxl" type="submit"
                    (click)="camTestKo()">
                    {{ 'DISCONNECTED.AUDIO.NO' | translate }}
                  </button>
                  <button class="btn btn-primary btn-lg u-divider-top-xxl" type="submit"
                    (click)="camTestOk()">
                    {{ 'DISCONNECTED.AUDIO.YES' | translate }}
                  </button>
                }
              </div>
            }
          </div>

          <!-- TEST ERROR -->
          <!-- ESCENARIO TIPO: ICONO + TEXTO 1 / TEXTO 2 (cambiaremos el icono y el texto dependiendo de que paso del test nos encontremos.
              Los dos textos van a la vez, pero para mantener una misma estructura de 2 parrafos)-->
          <!-- Para Doctor el núm. de teléfono de contacto es siempre 33333 -->
          @if(noConnectivityTestPassed){
            <div class="error-settings">
              <i class="icon-wifi"></i>
              <div class="u-divider-bottom-xl u-divider-top-xl">
                {{ 'MUTUA_NETWORK_TEST.NO_CONNECTIVITY_TEST_PASSED' | translate }}
              </div>
              <!-- @if(roleType === ROLES_TYPE.AMPHITRYON_SHORT){
                <div class="u-divider-bottom-xl"
                  [innerHTML]="'MUTUA_NETWORK_TEST.NO_CONNECTIVITY_TEST_PASSED_AMPHITRYON' | translate"></div>
              }
              @if(roleType === ROLES_TYPE.USER_SHORT && !allPhonesNull){
                <div class="u-divider-bottom-xl"
                  [innerHtml]="'MUTUA_NETWORK_TEST.NO_DEVICES_TEST_PASSED_EXTRA_USER' | translate"></div>
              }
              @if(roleType === ROLES_TYPE.USER_SHORT && dualCam){
                <div class="u-divider-bottom-xl"
                  [innerHtml]="'MUTUA_NETWORK_TEST.NO_DEVICES_TEST_PASSED_EXTRA_USER' | translate"></div>
              }
              @if(roleType === ROLES_TYPE.USER_SHORT && allPhonesNull){
                <div class="u-divider-bottom-xl"
                  [innerHTML]="'MUTUA_NETWORK_TEST.NO_DEVICES_TEST_PASSED_EXTRA_USER_2' | translate"></div>
              }
              <div class="u-divider-bottom-xl" [translate]="'MUTUA_NETWORK_TEST.NO_CONNECTIVITY_TEST_PASSED_EXTRA'"></div> -->
              @if(roleType === ROLES_TYPE.AMPHITRYON_SHORT){
                <div
                  class="u-divider-bottom-xl"
                  [innerHTML]="'MUTUA_NETWORK_TEST.NO_CONNECTIVITY_TEST_PASSED_AMPHITRYON' | translate"
                ></div>
              }
              @if(roleType === ROLES_TYPE.USER_SHORT && !allPhonesNull) {

                <div
                  class="u-divider-bottom-xl"
                  [innerHtml]="
                    'MUTUA_NETWORK_TEST.NO_DEVICES_TEST_PASSED_EXTRA_USER'
                      | translate : { phoneNumber: phoneNumberToCall }
                  "
                ></div>
              }
              @if(roleType === ROLES_TYPE.USER_SHORT && dualCam){
                <div
                  class="u-divider-bottom-xl"
                  [innerHtml]="
                    'MUTUA_NETWORK_TEST.NO_DEVICES_TEST_PASSED_EXTRA_USER'
                      | translate : { phoneNumber: phoneNumberToCall }
                  "
                ></div>
              }
              @if(roleType === ROLES_TYPE.USER_SHORT && allPhonesNull){
                <div
                  class="u-divider-bottom-xl"
                  [innerHTML]="'MUTUA_NETWORK_TEST.NO_DEVICES_TEST_PASSED_EXTRA_USER_2' | translate"
                ></div>
              }
              <div
                class="u-divider-bottom-xl"
                translate="MUTUA_NETWORK_TEST.NO_CONNECTIVITY_TEST_PASSED_EXTRA"
              ></div>
            </div>
          }
          @if(noAudioSpeakersTestPassed){
            <div class="error-settings">
              @if(typeDeviceErrorMessage === 'audio'){
                <i class="icon-display-audio"></i>
              }
              @if(typeDeviceErrorMessage === 'mic'){
                <i class="icon-mic"></i>
              }
              @if(typeDeviceErrorMessage === 'cam'){
                <i class="icon-camera"></i>
              }
              <div class="u-divider-bottom-xl u-divider-top-xl" [translate]="'MUTUA_NETWORK_TEST.NO_DEVICES_TEST_PASSED'">
              </div>
              @if(roleType === ROLES_TYPE.AMPHITRYON_SHORT){
                <div class="u-divider-bottom-xl"
                  [innerHTML]="'MUTUA_NETWORK_TEST.NO_DEVICES_TEST_PASSED_EXTRA_AMPHITRYON' | translate"></div>
              }
              @if(roleType === ROLES_TYPE.USER_SHORT && !allPhonesNull){
                <div class="u-divider-bottom-xl"
                  [innerHtml]="'MUTUA_NETWORK_TEST.NO_DEVICES_TEST_PASSED_EXTRA_USER' | translate : { phoneNumber: phoneNumberToCall }"></div>
              }
              @if(roleType === ROLES_TYPE.USER_SHORT && allPhonesNull){
                <div class="u-divider-bottom-xl"
                  [innerHTML]="'MUTUA_NETWORK_TEST.NO_DEVICES_TEST_PASSED_EXTRA_USER_2' | translate"></div>
              }
            </div>
          }
        </div>

        <!-- TEST RESULT CONTAINER -->
        @if(devicesTestActivate && !dualCam){
          <div class="overlay-info-container test-container">
            @if(!showConnectivityTestResults){
              <div class="u-flex u-flex-justify-content-between u-divider-bottom-sm">
                <div class="u-flex u-flex-align-items-center test-container-item">
                  <div [translate]="'DISCONNECTED.TEST.VIDEO'"></div>
                  <i [ngClass]="{
                      'icon-check': videoTest,
                      'icon-close': !videoTest
                    }"></i>
                </div>
                <div class="u-flex u-flex-align-items-center test-container-item">
                  <div [translate]="'DISCONNECTED.TEST.AUDIO'"></div>
                  <i [ngClass]="{
                      'icon-check': audioTest,
                      'icon-close': !audioTest
                    }"></i>
                </div>
                <div class="u-flex u-flex-align-items-center test-container-item">
                  <div [translate]="'DISCONNECTED.TEST.NET'"></div>
                  <i [ngClass]="{
                      'icon-check': networkTest,
                      'icon-close': !networkTest
                    }"></i>
                </div>
              </div>
            }
            @if(!showConnectivityTestResults && networkTest){
              <div class="bold u-txt-center t-green"
                [translate]="'DISCONNECTED.TEST.MSG_OK'"></div>
            }
            @if(!showConnectivityTestResults && !networkTest){
              <div class="bold u-txt-center t-red"
                [translate]="'DISCONNECTED.TEST.MSG_KO'"></div>
            }
            @if(showConnectivityTestResults){
              <div class="bold u-txt-center" [translate]="'DISCONNECTED.TEST.MSG_INFO'">
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
@if(devicesErrorMessage || showWhiteList){
  <div class="popup-msg">
    @if(showWhiteList){
      <div class="overlay-info-container">
        <h3 class="u-divider-bottom-xl" [translate]="popUpMessage || ''"></h3>
        <h3 class="whiteList-title-margin-top">
          {{ 'MUTUA_NETWORK_TEST.NO_SUPPORTED_BROWSER_EXPERIENCE' | translate }}
        </h3>
        <h4 class="whiteList-title-margin-top">
          <b>{{ 'MUTUA_NETWORK_TEST.WHITE_LIST_TITLE' | translate }}</b>
        </h4>
        <h4 class="whiteList-title-margin-top">
          {{
          'MUTUA_NETWORK_TEST.ANDROID_SUPORTED_BROWSER'
          | translate : { version: whiteListVersions.chromeAndroid }
          }}
        </h4>
        <h4>
          {{
          'MUTUA_NETWORK_TEST.WINDOWS_CHROME_SUPORTED_BROWSER'
          | translate : { version: whiteListVersions.chromeWindows }
          }}
        </h4>
        <h4>
          {{
          'MUTUA_NETWORK_TEST.WINDOWS_EDGE_SUPORTED_BROWSER'
          | translate : { version: whiteListVersions.edgeWindows }
          }}
        </h4>
        <h4>
          {{
          'MUTUA_NETWORK_TEST.APPLE_SUPORTED_BROWSER'
          | translate : { version: whiteListVersions.safari }
          }}
        </h4>
        <button class="btn btn-primary btn-lg u-divider-top-xl" type="submit" (click)="acceptNotSupportedBrowser()">
          {{ 'MUTUA_NETWORK_TEST.ACCEPT_BUTTON' | translate }}
        </button>
      </div>
    }@else {
      <div class="overlay-info-container">
        <h3 class="u-divider-bottom-xl" [translate]="popUpMessage || ''"></h3>
        <h4 class="u-divider-top-xl" [translate]="'MUTUA_NETWORK_TEST.REFRESH_PAGE'"></h4>
        <button class="btn btn-primary btn-lg u-divider-top-xl" type="submit" (click)="reloadPage()">
          {{ 'MUTUA_NETWORK_TEST.REFRESH_BUTTON' | translate }}
        </button>
      </div>
    }
  </div>
}
@if(getNetWorkTestCredentialsError){
  <div class="popup-msg">
    <div class="overlay-info-container">
      <h3 class="u-divider-bottom-xl" [translate]="popUpMessage || ''"></h3>
      <button class="btn btn-primary btn-lg u-divider-top-xl" type="submit" (click)="reloadPage()">
        {{ 'MUTUA_NETWORK_TEST.REFRESH_BUTTON' | translate }}
      </button>
    </div>
  </div>
}
@let showLostSignalModal = showLostSignalModal$ | async;
@if(showLostSignalModal){
  <div class="popup-msg">
    <div class="overlay-info-container">
      <h3 class="u-divider-bottom-xl" [translate]="'MUTUA_NETWORK_TEST.LOST_SIGNAL_ERROR'"></h3>
      <h4 class="u-divider-top-xl" [translate]="'MUTUA_NETWORK_TEST.RELOAD_TEST_PAGE'"></h4>
      <button class="btn btn-primary btn-lg u-divider-top-xl" type="submit" (click)="closeModalLostSignal()">
        {{ 'MUTUA_NETWORK_TEST.ACCEPT_BUTTON' | translate }}
      </button>
    </div>
  </div>
}